'use client';
import {
    ContactCardEmailItem,
    ContactCardInstitutionItem,
    ContactCardNameItem,
    ContactCardPhoneItem
} from '../contactcard/items';
import { TitleLarge } from '../../styles';
import { User } from '../../types';
import { ContactInfoContainer } from './styles';
import { useTranslations } from 'next-intl';

type ContactInfoProps = {
    user: Partial<User>;
    personal?: boolean;
};
export const ContactInfoUser = ({ user, personal = true }: ContactInfoProps) => {
    const t_profile = useTranslations('profile');
    const { email, phone, institution } = user;

    return (
        <ContactInfoContainer>
            {personal && <TitleLarge>{t_profile('contact_info')}</TitleLarge>}
            <ContactCardNameItem user={user} />
            {institution && (
                <ContactCardInstitutionItem type={institution.type} name={institution.name} />
            )}
            {email && <ContactCardEmailItem email={email} />}
            {phone && <ContactCardPhoneItem phoneNumber={phone} />}
        </ContactInfoContainer>
    );
};
